import React from "react";
import './ReportIssueBtn.css'
import report_issue_icon from '../assets/report_issue_icon.svg'

function ReportIssueBtn({onClick}) {
    
    return (
        <div className="wrapper" onClick={onClick}> 
            <img className='img' src={report_issue_icon} alt='Report an issue icon'/>
            Report an issue
        </div>
    );
}

export default React.memo(ReportIssueBtn);